module.exports = __webpack_public_path__ + "static/media/ScrollBarLeft.cf1aa9ba.svg";